import {useState} from 'react'
import {Link} from 'react-router'
import {useQuery} from '@tanstack/react-query'
import {listScenarios} from '../../api/scenarios.js'
import {usePolling} from '../../hooks/use-polling.js'
import {listActiveScenarios} from '../../api/scenarios.js'
import {FilterTabs} from '../../components/filter-tabs/filter-tabs.jsx'
import {ScenarioCard} from '../../components/scenario-card/scenario-card.jsx'
import styles from './scenarios.module.scss'

const FILTERS = [
    {value: 'all', label: 'All'},
    {value: 'active', label: 'Active'},
    {value: 'disabled', label: 'Disabled'}
]

export function Scenarios() {
    const [filter, setFilter] = useState('all')
    const {data: allData, isLoading: loadingAll} = useQuery({
        queryKey: ['scenarios'],
        queryFn: listScenarios,
        staleTime: 30_000
    })
    const {data: activeData} = usePolling({
        queryKey: ['scenarios', 'active'],
        queryFn: listActiveScenarios,
        intervalMs: 5_000,
        staleTime: 0
    })

    const activeIds = new Set((activeData?.active || []).map(s => s.id))
    const scenarios = allData?.scenarios || []
    const filtered = scenarios.filter(s => {
        if (filter === 'active')
            return activeIds.has(s.id)
        if (filter === 'disabled')
            return s.disabled
        return true
    })

    return (
        <div className={styles.screen}>
            <header className={styles.header}>
                <p className={styles.eyebrow}>Automations</p>
                <h1 className={styles.title}>Scenarios</h1>
            </header>
            <FilterTabs value={filter} options={FILTERS} onChange={setFilter}/>
            <div className={styles.list}>
                {loadingAll && Array.from({length: 3}).map((_, i) => (
                    <div key={i} className={styles.skeleton} aria-busy="true"/>
                ))}
                {!loadingAll && filtered.length === 0 && (
                    <p className={styles.empty}>No scenarios match this filter.</p>
                )}
                {filtered.map(scenario => (
                    <Link key={scenario.id} to={`/scenarios/${scenario.id}`} className={styles.cardLink}>
                        <ScenarioCard
                            scenario={scenario}
                            active={activeIds.has(scenario.id)}
                        />
                    </Link>
                ))}
            </div>
        </div>
    )
}
